import { PageTypeEnum, ProductInfoProduct, UpsellProduct } from '../types'

export type ModuleContext = {
  key: number
  flags: Record<string, boolean>
  pageType: PageTypeEnum
}

export type ModuleTwoColumn = {
  __typename: 'ModuleTwoColumn'
  left: Module[]
  right: Module[]
  ratio?: '60/40' | '50/50'
}

export type ModuleTwoColumnProductHeading = {
  __typename: 'ModuleTwoColumnProductHeading'
  left: Module[]
  right: Module[]
}

export type Tab = {
  title: string
  label: string
  modules: Module[]
}

export type ModuleMultiBuyTabs = {
  __typename: 'ModuleMultiBuyTabs'
  tabs: Tab[]
  meta: { intent: string }
}

export type GroupCardTab = Tab & {
  type: 'SINGLE' | 'GROUP'
}

export type ModuleGroupCardTabs = {
  __typename: 'ModuleGroupCardTabs'
  tabs: GroupCardTab[]
  meta: { intent: string }
}

export type ModuleTabs = {
  __typename: 'ModuleTabs'
  tabs: Tab[]
  meta?: { intent: string }
}

export type ModuleSingleCard = {
  __typename: 'ModuleSingleCard'
}

export type ModuleTitle = {
  __typename: 'ModuleTitle'
}

export type ModuleHeading = {
  __typename: 'ModuleHeading'
  textType?: 'heading' | 'step heading'
}

export enum ModuleVariantsType {
  RADIO = 'radio',
  DROPDOWN = 'dropdown',
  GRID = 'grid',
}

export type ModuleVariants = {
  __typename: 'ModuleVariants'
  type: ModuleVariantsType
  unavailableVariants?: string[]
}

export type ModuleVariantsExperiment = {
  __typename: 'ModuleVariantsExperiment'
  unavailableVariants?: string[]
}

export type ModuleDispatch = {
  __typename: 'ModuleDispatch'
}

export type ModuleButtons = {
  __typename: 'ModuleButtons'
  productType?: 'groupCard'
}

export type ModuleMoreInfo = {
  __typename: 'ModuleMoreInfo'
}

export type ModuleGroupCards = {
  __typename: 'ModuleGroupCards'
}

export type ModuleQuantity = {
  __typename: 'ModuleQuantity'
}

export type ModulePromotions = {
  __typename: 'ModulePromotions'
}

export type ModuleImages = {
  __typename: 'ModuleImages'
}

export type ModuleLink = {
  __typename: 'ModuleLink'
  href: string
  title: string
  meta: {
    intent: string
  }
}

export type ModulePrice = {
  __typename: 'ModulePrice'
}

export type ModuleRating = {
  __typename: 'ModuleRating'
}

export type ModulePeopleAlsoViewed = {
  __typename: 'ModulePeopleAlsoViewed'
}

export type ModulePeopleAlsoViewedVariant = {
  __typename: 'ModulePeopleAlsoViewedVariant'
}

export type ModulePills = {
  __typename: 'ModulePills'
  show?: 'primary only' | 'all'
}

export type ModuleThingsToKnow = {
  __typename: 'ModuleThingsToKnow'
}

export type ModuleList = {
  __typename: 'ModuleList'
  title: string
  items: string[]
}

export type ModuleAddons = {
  __typename: 'ModuleAddons'
}

export type ModuleUpsell = {
  __typename: 'ModuleUpsell'
}

export type ModuleMemberPricingHeader = {
  __typename: 'ModuleMemberPricingHeader'
}

export type ModuleOutOfStock = {
  __typename: 'ModuleOutOfStock'
}

type ModuleFromPrice = {
  __typename: 'ModuleFromPrice'
}

export type ModuleFromPriceFrictionless = {
  __typename: 'ModuleFromPriceFrictionless'
}

type ModuleKlarnaInfo = {
  __typename: 'ModuleKlarnaInfo'
}

export type ModuleVariantTabs = {
  __typename: 'ModuleVariantTabs'
  modules: Module[]
}

type ModuleVariantList = {
  __typename: 'ModuleVariantList'
}

type ModuleProductDetails = {
  __typename: 'ModuleProductDetails'
}

export type Module =
  | ModuleMultiBuyTabs
  | ModuleGroupCardTabs
  | ModuleSingleCard
  | ModuleTwoColumn
  | ModuleTitle
  | ModuleVariants
  | ModuleVariantsExperiment
  | ModuleDispatch
  | ModuleButtons
  | ModuleMoreInfo
  | ModuleGroupCards
  | ModuleQuantity
  | ModulePromotions
  | ModuleImages
  | ModuleLink
  | ModulePrice
  | ModulePeopleAlsoViewed
  | ModulePeopleAlsoViewedVariant
  | ModulePills
  | ModuleRating
  | ModuleThingsToKnow
  | ModuleList
  | ModuleAddons
  | ModuleTabs
  | ModuleUpsell
  | ModuleMemberPricingHeader
  | ModuleOutOfStock
  | ModuleFromPrice
  | ModuleFromPriceFrictionless
  | ModuleVariantTabs
  | ModuleKlarnaInfo
  | ModuleVariantList
  | ModuleHeading
  | ModuleTwoColumnProductHeading
  | ModuleProductDetails

export type OnConfigureModulesCallback = ({
  product,
  upsellProduct,
}: {
  product: ProductInfoProduct
  upsellProduct?: UpsellProduct
}) => Module[]
